import * as React from "react";

import { cn } from "@/lib/utils";
import { motion } from "motion/react";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    // @ts-expect-error - mistyping
    <motion.textarea
      layout
      className={cn(
        "flex min-h-[80px] w-full rounded-l-md rounded-t-md bg-very-light p-7 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      rows={8}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
